AFRAME.registerComponent('watchlist-table-controller', {

    init: function () {
        this.el.sceneEl.addEventListener('watchlist-table-request-data', this._onDataRequest.bind(this));
        this.el.sceneEl.addEventListener('watchlist-show-table', this._onDataRequest.bind(this));
        document.body.addEventListener('watchlist-data-loaded', this._onDataRequest.bind(this));
    },

    _getStockProperty: function (stock, property, defaultValue) {
        if (defaultValue === undefined) defaultValue = 0;
        return parseFloat(stock[property]) || defaultValue;
    },

    _normalizeStockData: function (data) {
        if (!data) return [];
        return Array.isArray(data) ? data : Object.values(data);
    },

    _buildRow: function (stock, holding) {
        const ticker = stock.ticker || 'N/A';
        const price  = this._getStockProperty(stock, 'price');

        let quantity = 0;
        if (holding) {
            quantity = parseFloat(holding.quantity) || 0;
        }
        if (quantity === 0 && stock.quantity) {
            quantity = parseFloat(stock.quantity) || 0;
        }

        const totalCostBasis = (holding && holding.price !== null && holding.price !== undefined)
            ? parseFloat(holding.price) : 0;

        const dailyChangePerc = this._getStockProperty(stock, 'todaysChangePerc');
        const dailyChangeVal  = this._getStockProperty(stock, 'todaysChange');

        const fmtDollar = (v) => '$' + Math.abs(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const fmtPerc   = (v) => Math.abs(v).toFixed(1) + '%';
        const sign      = (v) => v >= 0 ? '+' : '-';

        const priceStr = '$' + (parseFloat(price) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

        const dailyPercStr = sign(dailyChangePerc) + fmtPerc(dailyChangePerc);

        const dailyValStr = sign(dailyChangeVal) + fmtDollar(dailyChangeVal);

        let valueChangeStr = '';
        if (quantity > 0) {
            const vc = dailyChangeVal * quantity;
            valueChangeStr = sign(vc) + '$' + Math.abs(Math.round(vc)).toLocaleString('en-US');
        }

        let totalGainPercStr = '';
        let totalGainDollarStr = '';

        if (quantity > 0 && totalCostBasis > 0) {
            const currentVal   = (parseFloat(price) || 0) * quantity;
            const totalChange  = currentVal - totalCostBasis;

            totalGainDollarStr = sign(totalChange) + '$' + Math.abs(Math.round(totalChange)).toLocaleString('en-US');

            let totalPerc = 0;
            if (totalCostBasis !== 0) {
                totalPerc = ((currentVal - totalCostBasis) / totalCostBasis) * 100;
            }
            totalGainPercStr = sign(totalPerc) + Math.abs(totalPerc).toFixed(1) + '%';
        }

        const truncate = (str) => {
            if (window.WatchlistApp && window.WatchlistApp.Utils && window.WatchlistApp.Utils.truncateInputDisplay) {
                return window.WatchlistApp.Utils.truncateInputDisplay(str, 10);
            }
            return str;
        };

        return [
            ticker, 
            truncate(priceStr), 
            truncate(dailyPercStr), 
            truncate(dailyValStr), 
            truncate(valueChangeStr), 
            truncate(totalGainPercStr), 
            truncate(totalGainDollarStr)
        ];
    },

    _onDataRequest: function (evt) {
        const tableEl = document.querySelector('[watchlist-table]');
        if (!tableEl) return;

        if (evt && evt.type === 'watchlist-data-loaded' && !tableEl.getAttribute('visible')) {
            return;
        }

        let stockData = [];

        const WA = window.WatchlistApp || {};
        const State = WA.State || {};

        if (State.currentWatchlistData) {
            stockData = this._normalizeStockData(State.currentWatchlistData);
        } else {
            const stockCube = document.getElementById('stock-3d-cube');
            if (stockCube && stockCube.components && stockCube.components['stock-cube-visualizer'] && stockCube.components['stock-cube-visualizer'].stockInfo) {
                stockData = this._normalizeStockData(stockCube.components['stock-cube-visualizer'].stockInfo);
            }
        }

        if (!stockData || stockData.length === 0) {
            console.warn('[WatchlistTableCtrl] No stock data available');
            return;
        }

        const currentWatchlist = (State.allWatchlists || []).find(w => w.id === State.currentWatchlistId);
        const holdings = currentWatchlist ? (currentWatchlist.holdings || {}) : {};

        if (WA.Utils && typeof WA.Utils.sortStockData === 'function') {
            stockData = WA.Utils.sortStockData(
                stockData,
                State.currentSortOption || 'alphabetical',
                State.currentSortOrder  || 'asc',
                holdings
            );
        } else {
            stockData.sort((a, b) => (a.ticker || '').localeCompare(b.ticker || ''));
        }

        const header = ['Symbol', 'Current\nPrice', 'Price\nChange %', 'Price\nChange $', 'Value\nChange', 'Total %\nPrice Change', 'Total $\nValue Change'];
        const rows = stockData.map(stock => {
            const holding = holdings[stock.ticker] || null;
            return this._buildRow(stock, holding);
        });

        const tableData = [header, ...rows];

        if (tableEl && tableEl.components && tableEl.components['watchlist-table']) {
            tableEl.components['watchlist-table'].show(tableData);
        } else {
            console.warn('[WatchlistTableCtrl] watchlist-table component not found');
        }
    },
});
